module.exports = __webpack_public_path__ + "static/img/1073_big.6d40b4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1073_big.png
// module id = b/w/
// module chunks = 1